/**
 * oncefuegos - Shopify OS 2.0 Client Scripts & Motion Experience
 * Clean, reliable eCommerce functionality: AJAX Cart, Drawer, Lightbox & Hero
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Smooth scroll for internal anchor links & section navigation
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId && targetId !== '#') {
        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
          // Close mobile menu or drawer if open
          closeCartDrawer();
        }
      }
    });
  });

  // 2. AJAX Add to Cart listener for all product forms
  initAjaxAddToCart();

  // 3. Cart Drawer Triggers
  initCartTriggers();

  // 4. Mobile Navigation Menu Triggers
  initMobileMenu();

  // 5. Hero Cinematic Video & Subtle Entrance (Untouched video autoplay/loop)
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  initHeroCinematic(prefersReducedMotion);
});

/**
 * Native Shopify AJAX Cart Integration (Compatible with Section Store & App Drawers)
 */
function initAjaxAddToCart() {
  // Support click on standalone add to cart buttons (e.g. in Sculptural Gallery)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ajax-add-to-cart-btn');
    if (btn) {
      e.preventDefault();
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      const originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>AGREGANDO...</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(res => {
        if (!res.ok) throw new Error('Error al agregar al carrito');
        return res.json();
      })
      .then(item => {
        const cartAddEvent = new CustomEvent('cart:add', { bubbles: true, detail: { item: item } });
        const ajaxAddEvent = new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: item } });
        document.dispatchEvent(cartAddEvent);
        document.dispatchEvent(ajaxAddEvent);

        updateCartState(item);
        openCartDrawer();
      })
      .catch(err => {
        console.warn('Error adding variant:', err);
      })
      .finally(() => {
        btn.disabled = false;
        btn.innerHTML = originalHtml;
      });
    }
  });

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form && (form.classList.contains('js-ajax-add-to-cart') || form.id === 'ProductForm' || form.getAttribute('action') === '/cart/add' || form.getAttribute('action') === '/cart/add.js')) {
      e.preventDefault();
      
      const submitBtn = form.querySelector('button[type="submit"]') || form.querySelector('input[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span>AGREGANDO...</span>';
      }

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Error al agregar al carrito');
        }
        return response.json();
      })
      .then(item => {
        // Dispatch standard Shopify Cart events for Section Store and other apps
        const cartAddEvent = new CustomEvent('cart:add', { bubbles: true, detail: { item: item } });
        const ajaxAddEvent = new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: item } });
        document.dispatchEvent(cartAddEvent);
        document.dispatchEvent(ajaxAddEvent);

        // Update Cart Count & State
        updateCartState(item);
        
        // Open Cart Drawer (if no third party cart drawer takes precedence)
        openCartDrawer();
      })
      .catch(err => {
        console.warn('Shopify Cart AJAX fallback:', err);
        form.submit();
      })
      .finally(() => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
        }
      });
    }
  });
}

/**
 * Cart Drawer Open / Close / Toggle
 */
function initCartTriggers() {
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      toggleCartDrawer();
    });
  }
}

function openCartDrawer() {
  const drawer = document.getElementById('shopify-cart-drawer');
  if (drawer) {
    drawer.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('shopify-cart-drawer');
  if (drawer) {
    drawer.classList.add('hidden');
    document.body.style.overflow = '';
  }
}

function toggleCartDrawer() {
  const drawer = document.getElementById('shopify-cart-drawer');
  if (drawer) {
    if (drawer.classList.contains('hidden')) {
      openCartDrawer();
    } else {
      closeCartDrawer();
    }
  }
}

// Expose globally for inline onclick handlers
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;
window.toggleCartDrawer = toggleCartDrawer;

/**
 * Mobile Navigation Menu Drawer
 */
function initMobileMenu() {
  const openBtn = document.getElementById('mobile-menu-btn');
  const closeBtn = document.getElementById('close-mobile-menu-btn');
  const drawer = document.getElementById('mobile-drawer-overlay');

  if (openBtn && drawer) {
    openBtn.addEventListener('click', function () {
      drawer.classList.remove('opacity-0', 'pointer-events-none');
      drawer.classList.add('opacity-100', 'pointer-events-auto');
      document.body.style.overflow = 'hidden';
    });
  }

  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', function () {
      drawer.classList.remove('opacity-100', 'pointer-events-auto');
      drawer.classList.add('opacity-0', 'pointer-events-none');
      document.body.style.overflow = '';
    });
  }
}
window.initMobileMenu = initMobileMenu;

/**
 * Currency Formatter for Chilean Pesos / Store Currency
 */
function formatMoney(cents) {
  if (cents === null || cents === undefined) return '$0';
  const amount = Math.round(cents / 100);
  try {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    }).format(amount);
  } catch (e) {
    return '$' + amount.toLocaleString('es-CL');
  }
}

/**
 * Updates item quantity in the cart via native Shopify AJAX
 */
function updateCartItemQuantity(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: key,
      quantity: Math.max(0, parseInt(quantity, 10))
    })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartState(null, cart);
  })
  .catch(err => {
    console.error('Error updating cart item quantity:', err);
  });
}
window.updateCartItemQuantity = updateCartItemQuantity;

/**
 * Synchronizes cart state, drawer HTML, badges, and dispatches standard Shopify events
 */
function updateCartState(addedItem, cartData) {
  const handleCart = (cart) => {
    // 1. Update header badge & count indicators
    const countBadges = document.querySelectorAll('#cart-count-badge');
    countBadges.forEach(badge => {
      badge.innerText = cart.item_count;
      if (cart.item_count > 0) {
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }
    });

    const drawerCount = document.getElementById('cart-drawer-item-count');
    if (drawerCount) {
      drawerCount.innerText = `(${cart.item_count})`;
    }

    // 2. Render Drawer HTML items dynamically
    const emptyState = document.getElementById('shopify-cart-empty-state');
    const itemsList = document.getElementById('shopify-cart-items-list');
    const footerContainer = document.getElementById('shopify-cart-footer-container');
    const subtotalEl = document.getElementById('shopify-cart-subtotal');

    if (cart.item_count === 0) {
      if (emptyState) emptyState.classList.remove('hidden');
      if (itemsList) {
        itemsList.classList.add('hidden');
        itemsList.innerHTML = '';
      }
      if (footerContainer) footerContainer.classList.add('hidden');
    } else {
      if (emptyState) emptyState.classList.add('hidden');
      if (footerContainer) footerContainer.classList.remove('hidden');
      if (subtotalEl) {
        subtotalEl.innerText = formatMoney(cart.total_price);
      }

      if (itemsList) {
        itemsList.classList.remove('hidden');
        let html = '';
        cart.items.forEach(item => {
          const itemImage = item.featured_image ? item.featured_image.url || item.image : item.image;
          const variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
          
          html += `
            <div class="flex gap-4 p-4 bg-[#181614] border border-white/10 shadow-lg" data-cart-item-key="${item.key}">
              <a href="${item.url}" class="w-20 h-20 bg-[#12110F] overflow-hidden flex-shrink-0 block group border border-white/5">
                <img
                  src="${itemImage}"
                  alt="${item.title}"
                  class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </a>
              <div class="flex-1 flex flex-col justify-between">
                <div>
                  <div class="flex items-start justify-between gap-2">
                    <h4 class="font-serif text-base sm:text-lg text-[#FAF7F2] font-light leading-snug">
                      <a href="${item.url}" class="hover:text-[#E25822] transition-colors">
                        ${item.product_title || item.title}
                      </a>
                    </h4>
                    <button
                      type="button"
                      onclick="updateCartItemQuantity('${item.key}', 0)"
                      class="text-[#D4C7B0] opacity-40 hover:opacity-100 hover:text-red-400 transition-all p-1"
                      title="Eliminar producto"
                      aria-label="Eliminar ${item.title}"
                    >
                      <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                      </svg>
                    </button>
                  </div>
                  ${variantTitle ? `<p class="text-xs font-mono text-[#E25822] mt-0.5">${variantTitle}</p>` : ''}
                </div>

                <div class="flex justify-between items-center font-mono text-xs pt-3 border-t border-white/5 mt-2">
                  <div class="flex items-center border border-white/10 bg-[#12110F]">
                    <button
                      type="button"
                      onclick="updateCartItemQuantity('${item.key}', ${item.quantity - 1})"
                      class="px-2 py-1 hover:bg-[#1A1816] text-[#D4C7B0] hover:text-white transition-colors"
                      aria-label="Disminuir cantidad"
                    >
                      -
                    </button>
                    <span class="px-2.5 text-xs text-[#FAF7F2] font-mono">${item.quantity}</span>
                    <button
                      type="button"
                      onclick="updateCartItemQuantity('${item.key}', ${item.quantity + 1})"
                      class="px-2 py-1 hover:bg-[#1A1816] text-[#D4C7B0] hover:text-white transition-colors"
                      aria-label="Aumentar cantidad"
                    >
                      +
                    </button>
                  </div>

                  <span class="font-serif text-base text-[#FAF7F2] font-light">${formatMoney(item.final_line_price)}</span>
                </div>
              </div>
            </div>
          `;
        });
        itemsList.innerHTML = html;
      }
    }

    // 3. Dispatch standard Shopify cart events
    const updateEvent = new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, item: addedItem } });
    const refreshEvent = new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } });
    const changeEvent = new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } });
    document.dispatchEvent(updateEvent);
    document.dispatchEvent(refreshEvent);
    document.dispatchEvent(changeEvent);
    window.dispatchEvent(updateEvent);
  };

  if (cartData) {
    handleCart(cartData);
  } else {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => handleCart(cart))
      .catch(() => {});
  }
}

/**
 * Clean Cinematic Background Video Initialization
 * Ensures HTML5 autoplay, muted, playsinline, loop across all devices.
 * Zero scroll listeners, zero currentTime manipulation, zero scrubbing.
 */
function initHeroCinematic(reducedMotion) {
  const heroSections = document.querySelectorAll('.hero-cinematic-section');
  if (!heroSections.length) return;

  heroSections.forEach((section) => {
    const video = section.querySelector('.hero-video');
    const mediaWrapper = section.querySelector('.hero-media-wrapper, .hero-image-inner');

    if (video) {
      video.muted = true;
      video.playsInline = true;
      video.autoplay = true;
      video.loop = true;

      const playVideo = () => {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // If browser blocks autoplay policy, poster remains visible.
          });
        }
      };

      playVideo();
      video.addEventListener('loadeddata', playVideo, { once: true });
      video.addEventListener('canplay', playVideo, { once: true });
    }

    // Subtle entrance animation
    if (!reducedMotion && mediaWrapper) {
      mediaWrapper.style.opacity = '0.92';
      mediaWrapper.style.filter = 'brightness(0.88) contrast(1.02)';
      mediaWrapper.style.transition = 'opacity 1.6s ease-out, filter 1.6s ease-out';
      
      requestAnimationFrame(() => {
        mediaWrapper.style.opacity = '1';
        mediaWrapper.style.filter = 'brightness(0.92) contrast(1.04)';
      });
    }
  });
}
